export default __webpack_public_path__ + "static/media/qr-code_rockbiosa.37c68d32.png";